import React, { useEffect, useState } from 'react';
import emailjs from '@emailjs/browser';

export const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [isSent, setIsSent] = useState(false);

  useEffect(() => {
    document.title = 'Abhinav - Contact';
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Replace these with your EmailJS keys
    const serviceID = 'service_tqksihp';
    const templateID = 'template_p66khde';
    const publicKey = 'WN5JjVbRepdpn8dwt';
    
    console.log("formdata: ");
    console.log(formData);

    const templateParams = {
      from_name: formData.name, 
      from_email: formData.email, 
      reply_to: formData.email,
      to_name: "Abhinav", 
      message: formData.message
    }

    emailjs.send(serviceID, templateID, templateParams, publicKey)
      .then((response) => {
        console.log('Message sent successfully!', response.status, response.text);
        setIsSent(true);
        setFormData({ name: '', email: '', message: '' }); // Reset form
      })
      .catch((err) => {
        console.error('Failed to send message:', err);
      });
  };

  return (
    <div className="container">
      <div className="section-mid">
        <p className="paragraph">
          I believe in the power of networking to drive growth and foster innovation. If you’re interested in collaborating on a project, discussing game tech, or just having a conversation about the future of gaming, feel free to reach out through my contact page. Let’s join forces and create something extraordinary together!
        </p>
        <div className="h-rule"></div>
        <form onSubmit={handleSubmit} className="form fx-col">
          <div className="form-group fx-align-start fx-col">
            <label htmlFor="name" className="txt-upper font-secondary">Name</label>
            <input
              type="text"
              name="name"
              id="name"
              className="input-field"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group fx-align-start fx-col">
            <label htmlFor="email" className="txt-upper font-secondary">Email</label>
            <input
              type="email"
              name="email"
              id="email"
              className="input-field"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group fx-col">
            <label htmlFor="message" className="txt-upper font-secondary">Message</label>
            <textarea
              name="message"
              id="message"
              rows={7}
              className="input-field"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
          </div>
          <div className="form-group">
            <button className="txt-upper font-secondary button" >SEND</button>
          </div>
        </form>
        {isSent && <p className="success-message">Thank you! Your message has been sent.</p>}
      </div>
    </div>
  );
};
